import { render, staticRenderFns } from "./Form13CaseInformation.vue?vue&type=template&id=6d2a4a75&scoped=true"
import script from "./Form13CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form13CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a4a75",
  null
  
)

export default component.exports